import { COLORS } from '@btime/constants'
import { parseBoolean } from '@btime/helpers'
import { map, pathOr, prop } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import BetweenValueInput from '../../../components/form/BetweenValueInput'
import DynamicInput from '../../../components/form/DynamicInput'
import NumberInput from '../../../components/form/NumberInput'
import Select from '../../../packages/kiti/components/form/Select'
import TagPicker from '../../../components/form/TagPicker'
import PlaceSelect from '../../places/select/PlaceSelect'
import { usePlaces } from '../../../modules/checklists/edit/_load/PlacesLoader'
import { useSelectedQuestion } from '../../../modules/checklists/edit/_form/ChecklistFormHandler'

const NumberValueInput = ({ value, operator, onChange, ...props }) => {
  return <NumberInput onStopTyping={v => onChange(v !== undefined ? parseFloat(v) : v)} value={value} {...props} />
}

const SelectValueInput = ({ value, operator, onChange, options, ...props }) => {
  return (
    <Select
      onChange={onChange}
      value={value}
      options={(options || []).filter(prop('name'))}
      idField="reference"
      multiple
      {...props}
    />
  )
}

const ConditionValueInput = ({ type, value, operator, onChange, filter, ...props }) => {
  const { t } = useTranslation()
  const places = usePlaces()
  const selectedQuestion = useSelectedQuestion()

  const getPlaceLevelIds = selectedQuestion => {
    const placeLevelIds = pathOr([], ['data', 'filter', 'placeLevelIds'], selectedQuestion)
    const ids = map(prop('id'), placeLevelIds)
    if (!ids.length) return undefined
    return { placeLevelIds: ids }
  }

  const placeLevelIds = getPlaceLevelIds(selectedQuestion)

  const getPlaceInputValueByPlaceIds = (placesIds, places) => {
    if (placesIds === undefined) return
    return places.filter(place => placesIds.includes(place.id))
  }

  switch (type) {
    case 'checkbox':
      return <DynamicInput value={value} valueType={type} onChange={onChange} {...props} />
      var options = [
        { label: t('yes'), value: true, selectedColor: COLORS.green },
        { label: t('no'), value: false, selectedColor: COLORS.red }
      ]
      const bValue = value === null ? null : parseBoolean(value)
      return <TagPicker onStopChanging={onChange} value={bValue} {...props} options={options} />

    case 'float':
    case 'numeric':
    case 'calc':
      const isRange = ['btwn', 'nbtwn'].includes(operator)
      if (isRange) return <BetweenValueInput value={value} onChange={onChange} {...props} />
      return <NumberValueInput value={value} onChange={onChange} {...props} />

    case 'select':
    case 'multiple':
      return <SelectValueInput value={value} onChange={onChange} {...props} />

    case 'place':
      return (
        <PlaceSelect
          onChange={onChange}
          value={getPlaceInputValueByPlaceIds(value, places)}
          filter={placeLevelIds}
          multiple
        />
      )

    default:
      return false
  }
}

export default ConditionValueInput
